import { Button, MenuItem, Paper } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Header from "../../../partials/header";
import InputFormat from "../../../partials/inputForm";
import languages from "../../../utils/languages.json";
import InputFileReader from "../../fileReader";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import SelectCategory from "../modalCategories";
import { styles } from "./styles";
import TextEditor from "../../textEditor";
import LabelForm from "../../../partials/labelForm";
import ReviewContent from "../../descriptionComponent/review";

const DEFAULT_STATE = {
  post: {
    service: {},
    creator: {},
    slug: "",
    langContent: [],
    isPublish: true,
    categories: [],
  },
  contentData: {
    title: "",
    description: "",
    lang: "vi",
    content: "",
    featureImage: "",
  },
};
class Posts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      post: null,
      contentData: null,
    };
    this.loadPost = this.loadPost.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.snackbar = this.snackbar.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addCategory = this.addCategory.bind(this);
  }
  componentDidMount = async () => {
    this.loadPost();
  };
  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname != this.props.location.pathname) {
      this.loadPost();
    }
  }
  async loadPost() {
    let { type } = this.props;
    this.setState({ post: null, contentData: null });
    if (type !== "update") {
      this.setState({ ...DEFAULT_STATE });
      return;
    }
    const { match } = this.props;
    const { params } = match;
    const { slug } = params;
    this.loading.startLoading();
    let response = await this.props.getBySlug({
      slug: slug,
      snackbar: this.snackbar,
    });
    this.loading.stopLoading();
    if (response.code !== 1) {
      return;
    }

    this.setState({
      post: response.data,
      contentData: response.data.langContent[0],
    });
  }
  handleChange = (event) => {
    const { name, value } = event.target;
    let { contentData, post } = this.state;

    if (
      ["title", "description", "content", "featureImage", "lang"].includes(name)
    ) {
      this.setState({
        contentData: { ...contentData, [name]: value },
      });
      return;
    }
    this.setState({ post: { ...post, [name]: value } });
  };

  handleSubmit = async () => {
    try {
      const { t, type, serviceCode } = this.props;
      let { post, contentData } = this.state;
      let file = this.InputFileReader.getFile();
      let src = this.InputFileReader.getSrc();
      if (src !== null) {
        contentData.featureImage = src;
      }
      if (file != null) {
        const response = await this.props.uploadDispatch.saveStorage({
          files: file,
          code: serviceCode,
          type: "img-posts",
        });
        if (response.code === 1) {
          contentData.featureImage = response.data.previewLink;
        }
      }
      const data = {
        ...post,
        langContent: [contentData],
      };
      this.loading.startLoading();

      if (type === "update") {
        await this.props.update(data);
      } else {
        await this.props.create({
          ...contentData,
          categories: post.categories,
        });
      }
      this.loading.stopLoading();
      this.mSnackbar.handleClick(t("update_success"), "success");
    } catch (error) {
      const { t } = this.props;
      console.log(error);
      this.loading.stopLoading();
      this.mSnackbar.handleClick(
        t("An_error_occurred_Please_check_internet_or_contact_your_admin"),
        "error"
      );
    }
  };
  snackbar = (mess, type) => {
    this.mSnackbar.handleClick(mess, type);
  };
  addCategory = (categories) => {
    let { post } = this.state;
    post.categories = categories;
    this.setState({ post });
  };
  backToList = () => {};
  render() {
    const { classes, type, t } = this.props;
    const { post, contentData } = this.state;
    if (!post || !contentData) {
      return <Loading onRef={(id) => (this.loading = id)} />;
    }
    const { title, description, content, featureImage, lang } = contentData;

    return (
      <div>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <SelectCategory
          onRef={(dialog) => (this.selectCategory = dialog)}
          action={this.addCategory}
        />
        <Header
          session={t("post_list_posts")}
          title={t(`post_${type || "create"}_posts`)}
          backIcon={true}
          actionBack={() => this.backToList()}
        />
        <div style={{ marginTop: 24 }}>
          <Paper className={classes.paperRoot}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <InputFormat
                  label={t("post_title")}
                  name="title"
                  margin="normal"
                  required
                  type="text"
                  value={title}
                  fullWidth
                  onChange={this.handleChange}
                />
              </Grid>
              {type === "update" && (
                <Grid item xs={12} sm={12}>
                  <InputFormat
                    label={t("post_slug")}
                    name="slug"
                    disabled
                    margin="normal"
                    required
                    type="text"
                    value={post.slug}
                    fullWidth
                    onChange={this.handleChange}
                  />
                </Grid>
              )}

              <Grid item xs={6} sm={3}>
                <InputFormat
                  select
                  label={t("post_lang")}
                  name="lang"
                  margin="normal"
                  required
                  fullWidth
                  value={lang}
                  onChange={this.handleChange}
                >
                  {languages &&
                    Object.keys(languages).map((e) => {
                      return (
                        <MenuItem value={e}>{languages[e].nativeName}</MenuItem>
                      );
                    })}
                </InputFormat>
              </Grid>
              <Grid item xs={6} sm={3}>
                <InputFormat
                  select
                  label={t("post_publish")}
                  name="isPublish"
                  margin="normal"
                  required
                  fullWidth
                  value={
                    post.isPublish ? "post_publish_true" : "post_publish_false"
                  }
                  onChange={this.handleChange}
                >
                  <MenuItem value={"post_publish_true"}>
                    {t("post_publish_true")}
                  </MenuItem>
                  <MenuItem value={"post_publish_false"}>
                    {t("post_publish_false")}
                  </MenuItem>
                </InputFormat>
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputFormat
                  required
                  fullWidth
                  multiline
                  margin="normal"
                  onClick={() => this.selectCategory.handleOpen()}
                  value={
                    post.categories
                      ? post.categories.map((e) => e.name).join(", ")
                      : ""
                  }
                  onChange={this.handleChange}
                  style={{ cursor: "pointer" }}
                  label={t("post_category")}
                  name="categories"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <InputFormat
                  label={t("post_description")}
                  name="description"
                  margin="normal"
                  required
                  multiline
                  rows={2}
                  type="textarea"
                  fullWidth
                  value={description}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <InputFileReader
                  onRef={(id) => (this.InputFileReader = id)}
                  style={classes}
                  container="square"
                  defaultImg={featureImage || ""}
                  selectStorageMode={true}
                />
              </Grid>
              <Grid item xs={12}>
                <Grid
                  container
                  xs={12}
                  sm={12}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <LabelForm required={true} label={t("post_content")} />
                  <Button
                    onClick={() => {
                      this.reviewContentRef.open(content);
                    }}
                  >
                    {t("review")}
                  </Button>
                </Grid>
                <ReviewContent onRef={(id) => (this.reviewContentRef = id)} />
                <TextEditor
                  name="content"
                  onChange={this.handleChange}
                  value={content}
                />
              </Grid>

              <Grid item xs={12} style={{ textAlign: "right", marginTop: 8 }}>
                <Button
                  onClick={this.handleSubmit}
                  color="primary"
                  size="large"
                  variant="contained"
                  component="span"
                  className={classes.button}
                >
                  {t(`post_${type || "create"}`)}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </div>
      </div>
    );
  }
}

Posts.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
});

const mapDispatch = (dispatch) => ({
  create: dispatch.posts.create,
  getBySlug: dispatch.posts.getBySlug,
  update: dispatch.posts.update,
  uploadDispatch: dispatch.upload,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Posts)));
